import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Footer from 'mf-react-ui/Footer';
import HeaderContainer from '../../components/Header/HeaderContainer';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import IndexPageContainer from '../../pages/IndexPage/IndexPageContainer';
import PromoCodePageContainer from '../../pages/PromoCodePage/PromoCodePageContainer';
import OrdersPageContainer from '../../pages/OrdersPage/OrdersPageContainer';
import Message from '../../pages/OrdersPage/components/Message/Message';
import ContentAuth from '../../components/ContentAuth/ContentAuth';
import ThrobberForPage from '../../components/ThrobberForPage/ThrobberForPage';
import ModalRoot from '../../features/modals/ModalRoot';
import { AppRoute, ErrorMessage } from '../../const';
import './App.scss';

const App: React.FC = () => (
  <>
    <div className="page">
      <div className="page__header">
        <HeaderContainer />
      </div>
      <div className="page__body">
        <main className="page__main">
          <Switch>
            <Route exact path={`${AppRoute.ROOT}`}>
              <IndexPageContainer />
            </Route>
            <Route exact path={`${AppRoute.OFFER}/:slug`}>
              <IndexPageContainer />
            </Route>
            <Route exact path={AppRoute.PROMOCODE}>
              <ContentAuth
                contentWithAuth={<PromoCodePageContainer />}
                contentWithNoAuth={<PromoCodePageContainer />}
                contentWithPending={<ThrobberForPage />}
              />
            </Route>
            <Route exact path={AppRoute.ORDERS}>
              <ContentAuth
                contentWithAuth={<OrdersPageContainer />}
                contentWithNoAuth={<Message />}
                contentWithPending={<ThrobberForPage />}
              />
            </Route>
            <Route>
              <ErrorPage message={ErrorMessage.NOT_FOUND} />
            </Route>
          </Switch>
        </main>
      </div>
      <div className="page__footer">
        <Footer
          menuItemsContent={[
            <a key="1" href={AppRoute.LEGAL} target="_blank" rel="nofollow noopener noreferrer">
              Оферта
            </a>,
          ]}
        />
      </div>
    </div>
    <ModalRoot />
  </>
);

export default App;
